import axios from 'axios';
import * as types from '../mutation-types';
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // properties to store registry data
    endpoint: endpoints.registry.endpoint, // "registry",
    endpoints: endpoints.registry.endpoints, // "registries",
    registry: {},
  },
  // -----------------------------------------------------------------
  getters: {
    // getters and computed props on the registry data
    registry: state => state.registry,
  },
  // -----------------------------------------------------------------
  mutations: {
    // stuff to set roles data locally
  },
  // -----------------------------------------------------------------
  actions: {
    fetch: (context, paginationData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoints;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    read: (context, id) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + id;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    update: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + data.eid;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'PUT'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
  }
};
